module.exports = __webpack_public_path__ + "img/logo-visanet.36cab406.png";